import axios from 'axios';
import { notification } from 'antd';

export const useDelete = async (url, payload = {}) => {
  try {
    const header = {
      headers: { Authorization: localStorage.getItem('token') },
    };

    const dataRes = await axios.delete(url, payload, header);
    return dataRes;
  } catch (error) {
    if (error?.response?.status === 401) {
      notification.error({
        message: 'Unauthorized, please relogin to proceed',
      });
      localStorage.clear();
      window.location.reload();
      return;
    }
  }
};
